var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"indicator-overlay"},[_c('vue-simple-spinner',{staticClass:"spinner",style:({padding: '5rem'}),attrs:{"size":"big","line-fg-color":"#3c6bbb"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }